import { Layout } from '../components/Layout/Layout';
import { Login } from '../containers/Login/Login';
import styled from 'styled-components';

const SLayout = styled(Layout)`
  min-height: 100vh;
  height: 100%;
`;

export const LoginPage = () => {
  return (
    <SLayout isAuthLayout={false}>
      <Login />
    </SLayout>
  );
};
